"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotTrustedHost = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Link_1 = require("@skbkontur/react-ui/components/Link");

var PluginSetup_1 = require("../Control/PluginSetup");

var _1 = require(".");

exports.NotTrustedHost = function (_a) {
  var addToTrustedLink = _a.addToTrustedLink,
      onAccessConfirmed = _a.onAccessConfirmed,
      trackEvent = _a.trackEvent; // Сохраняем в замыкании фукнцию, которая будет вызываться из message: React.Node

  var onConfirmClick = function onConfirmClick() {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      var ps, accessConfirmed;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            trackEvent(_1.DisplayedErrorCodes.NotTrustedHost, 'confirmAccessLinkClick');
            ps = new PluginSetup_1.PluginSetup();
            return [4
            /*yield*/
            , ps.confirmAccessPopup()];

          case 1:
            accessConfirmed = _a.sent();

            if (accessConfirmed) {
              onAccessConfirmed();
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var onAddToTrustedClick = function onAddToTrustedClick() {
    trackEvent(_1.DisplayedErrorCodes.NotTrustedHost, 'addToTrustedLinkClick');
  };

  return {
    title: 'Сайт не в доверенных узлах',
    message: react_1.default.createElement("div", null, "\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0432\xA0", react_1.default.createElement(Link_1.Link, {
      "data-tid": "confirmAccessLink",
      onClick: onConfirmClick
    }, "\u0434\u0438\u0430\u043B\u043E\u0433\u043E\u0432\u043E\u043C \u043E\u043A\u043D\u0435"), ' ', "\u0438\u043B\u0438\xA0\u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u0444\u0430\u0439\u043B", ' ', react_1.default.createElement(Link_1.Link, {
      "data-tid": "addToTrustedLink",
      onClick: onAddToTrustedClick,
      href: addToTrustedLink
    }, "\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438"), ".", react_1.default.createElement("br", null), " \u0415\u0441\u043B\u0438 \u043D\u0435\xA0\u043F\u043E\u043C\u043E\u0433\u043B\u043E, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432\xA0\u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")
  };
};